import ActionTypes from '../../../constants/ActionTypes';
import { ICaptchaStore, ISetCaptchaRequiredActions } from "./types";

const initialState: ICaptchaStore = {
  isCaptchaRequired: false,
  entity: ''
};

const captchaReducer = (
  state = initialState,
  action: ISetCaptchaRequiredActions,
): ICaptchaStore => {
  switch (action.type) {
  case ActionTypes.SET_CAPTCHA_REQUIRED:
    return {
      ...state,
      isCaptchaRequired: action.payload.isCaptchaRequired,
      entity: action.payload.entity,
    };
  }

  return state;
};

export default captchaReducer;
